function MintedCard({ image }) {
    return <img className="w-full h-full rounded-lg " src={image} alt="claimed-card" />;
}

export default MintedCard;
